import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { customerServiceGetStartedEntryPoint } from '@atlassian/jira-spa-apps-customer-service-get-started/entrypoint.tsx';

export const customerServiceGetStartedPageEntryPoint = createPageEntryPoint({
	main: customerServiceGetStartedEntryPoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
});
